<template>
  <div v-if="!hasReachedLimit" class="w-100 buttonImitation totalDonations">
    Noch<br/>{{availableDonations}} verfügbare Zugänge
      <div v-if="preview" class="pl-05 pr-05 pb-1">
      <a v-if="!clicked" title="Jetzt spenden" class="w-100 button gsn-donate-button primary icon solid fa-heart"  href="#" @click.prevent="onClick()">{{btnDonateButton}}</a>
    </div>
  </div>
  <div v-else >
    <p class="text-center">Leider sind alle freien Plätze schon vergeben :-(</p>
    <p class="text-center">Eine Einbuchung in diesen Stream ist daher nicht mehr möglich. Aber schau dich doch bei den anderen Vorträgen einmal um.</p>
  </div>
</template>

<script>
import {projectBase} from '@/mixins/projectBase.js'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTProjectDonatorLimitSum',
  mixins:[projectBase,helper],
  components:{
    
  },
  props:{

    project:{
      type:Object
    },
    preview:{
      type:Boolean,
      default:false
    },
    show_people:{
      type:Boolean,
      default:false
    },
    limit:{
      type:Number,
      default:-1
    },
    stream_id:{
      type:String,
      default:null
    }
  },
  computed:{
    hasReachedLimit(){
      return this.availableDonations!=null && this.availableDonations<=0;
    },
    stream(){
      return this.getLastStreamByProjectId(this.project.id);
    },
    btnDonateButton(){
      return this.isSmallTouchDevice()?"ZUGANG SICHERN":"JETZT DANKESCHÖN-ZUGANG SICHERN"
    },
    availableDonations(){
      return (this.totalDonationPeopleByStream>=0 && this.limit>=0)?this.limit-this.totalDonationPeopleByStream:null;
    },
    totalDonationPeopleByStream(){
      let donations=(this.stream_id)?this.getStreamDonationsByStreamId(this.stream_id):null;
      return (donations)?donations.people:0;
    },
    totalDonationPeople(){
      let donations=(this.project)?this.getDonationsByProjectId(this.project.id):null;
      return (donations)?donations.people:0;
    },
  },
  data: function() {
    return {
      clicked:false
    };
  },
  methods:{

    onClick(){
      this.clicked=true;
      this.$emit('click');
    }
  }
};
</script>

<style scoped type='text/css'>
.donatorCount{
  font-size: 0.75em;
}
.gsn-donate-button{
  white-space: normal;
  height: auto;
}
.totalDonations{
  font-size: 2em;
  height:auto!important;
  white-space: normal;
}
@media screen and (max-width: 450px) {
.totalDonations{
  font-size: 1.5em;
  }
  .donationIcon{
    width:80%
  }
}
</style>